import { PublicClientApplication } from '@azure/msal-browser';

const clientId = process.env.REACT_APP_CLIENT_ID ;
const tenantId = process.env.REACT_APP_TENANT_ID ;

// msalConfig.js - Configuration for MSAL authentication
// This file exports the MSAL configuration object used for authentication in the application
const msalConfig = {
  auth: {
    clientId: clientId,
    authority: 'https://login.microsoftonline.com/'+tenantId,
    redirectUri: window.location.origin + "/ContractSearch",
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    // Persist tokens/accounts in localStorage so user stays signed in across navigations / reloads
    cacheLocation: "localStorage", // default is "sessionStorage"
    storeAuthStateInCookie: false
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export default msalConfig;